import { CommonModule } from '@angular/common'
import { Component, ElementRef, EventEmitter, Input, Output, viewChild } from '@angular/core'
import { Icon, IconComponent } from '../icon'
import { TooltipDisplay, TooltipModule } from '../tooltip'

export interface ToggleButtonTooltips {
  on: string
  off: string
}

export interface ToggleIcons {
  on: Icon
  off: Icon
}

@Component({
  selector: 'ftr-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.css'],
  standalone: true,
  imports: [CommonModule, IconComponent, TooltipModule],
})
export class ToggleButtonComponent {
  @Input() identifier?: string
  @Input() isOn: boolean
  @Input() tooltips?: ToggleButtonTooltips
  @Input() showTooltip: boolean = false
  @Input() icons: ToggleIcons
  @Input() testId?: string
  @Output() action = new EventEmitter()
  @Output() onValueChange = new EventEmitter<boolean>()

  buttonElement = viewChild.required<ElementRef<HTMLButtonElement>>('btn')

  readonly tooltipDisplay = TooltipDisplay

  onClick(event: MouseEvent): void {
    this.action.emit(event)
    this.onValueChange.emit(!this.isOn)
  }

  blur(): void {
    this.buttonElement().nativeElement.blur()
  }
}
